import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getDefaultCrew = (id) => {
        return axios.get(`${apiurl?.getDefaultCrew}?companyId=${id}`);
};

export default getDefaultCrew;
